//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      scrollY: 0,
      show: false
    };
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll: function handleScroll() {
      this.scrollY = window.pageYOffset;

      if (this.scrollY > 100) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    goPagetop: function goPagetop() {
      this.$SmoothScroll(document.querySelector('body'), 400, null, null, 'y');
    }
  }
};